class AdBuilder {

    constructor($rootScope) {
        
        this.REDUCTION = 0.11;
        this.$rootScope = $rootScope;

        let _self = this;

        return {
            restrict: 'E',
            scope: {
            	"canvas": "=",
                "adunit": "=",
                "workspaceOffset": "="
            },
            link: ($scope, $el, $attr) => {
                
                $scope.isDraggingWorkspace = false;

                this.$workspace = $('.workspace', $el);
                this.$scope = $scope;
                
            	this.$workspace.droppable({
            		accept: (draggable) => {
            			var asset = $(draggable).data("reflow-asset");
                        let willAccept = (!!asset) ? (asset.contentType === 'x-reflow/canvas' && !draggable.hasClass("layout-panel-item")) : false;
            			return willAccept;
            		},
            		over: (ev, ui) => {
            			$el.addClass("drag-over");
            		},
            		out: (ev, ui) => {
						$el.removeClass("drag-over");
            		},
            		drop: (ev, ui) => {
            			var asset = $(ui.draggable).data("reflow-asset");
            			_self.handleDrop.call(_self, asset, ui.position);
            			$scope.$apply();
            		}
            	});

                this.$workspace.draggable({
                    cursor: "move",
                    disabled: true,
                    drag: (ev, ui) => {
                        _self.handleDrag.call(_self, $scope, $el, ui);
                    }
                });

            	$el.mousedown( (ev) => {
            		if(ev.target == this.$workspace.get(0)) {
	            		$scope.$emit("select-builder");
                        _self.$rootScope.$emit("select-builder");
	            	}
            	});

                $(document).keydown( (ev) => {
                    if(ev.keyCode === 32 && !$scope.isDraggingWorkspace) {
                        _self.dragWorkspace.call(_self, $scope);
                    }
                });

			}
		};

	}

    dragWorkspace($scope) {
        $scope.isDraggingWorkspace = true;
        this.$workspace.draggable("option", "disabled", false);
        this.$rootScope.$emit('draggingWorkspace', true);
    }

    undragWorkspace($scope) {
        $scope.isDraggingWorkspace = false;
        this.$workspace.draggable("option", "disabled", true);
        this.$rootScope.$emit('draggingWorkspace', false);
    }

    handleDrag($scope, $el, ui) {

        if(ui.position.left < -(this.$workspace.width() - $el.width())) {
            ui.position.left = -(this.$workspace.width() - $el.width());
        }

        if(ui.position.top < -(this.$workspace.height() - $el.height())) {
            ui.position.top = -(this.$workspace.height() - $el.height());
        }

        if(ui.position.left > 0) {
            ui.position.left = 0;
        }

        if(ui.position.top > 0) {
            ui.position.top = 0;
        }
        $('.minimap-viewport').css({
            top: -ui.position.top * this.REDUCTION,
            left: -ui.position.left * this.REDUCTION
        })
    }

    handleDrop(asset, pos) {
    	var canvas = {
    		id: ObjectId(),
    		top: pos.top - this.$workspace.offset().top,
    		left: pos.left - this.$workspace.offset().left,
            layers: [],
            size: "MediumRectangle300x250",
            width: 300,
            height: 250,
            backgroundColour: "#ffffff",
            position: "inline",
            visibleInDesigner: true
    	};
    	$.extend(canvas, asset);
    	this.$scope.adunit.canvases.push(canvas);
    	this.$rootScope.$emit("add-canvas", canvas);
        this.$rootScope.$emit("select-canvas", canvas);
    }

}

angular.module('cpm')
    .directive('adBuilder', ['$rootScope', ($rootScope) => {
        'use strict';
        return new AdBuilder($rootScope);
    }]);
